package com.appsyde.shared.modules.ai.data.dto

import com.appsyde.shared.modules.ai.domain.model.AiRefineAction
import kotlinx.serialization.Serializable

@Serializable
data class AiRefineRequest(
    val action: AiRefineAction,
    val text: String
)
